import { Link } from "react-router-dom";
import { Skull, Heart, Swords } from "lucide-react";
import { API } from "@/lib/api";
import StarRating from "@/components/StarRating";

const TYPE_LABEL = {
  rpg: "Tabletop RPG",
  novel: "Novel",
  screenplay: "Screenplay",
  video_game: "Video Game",
  comic: "Comic",
  other: "Other",
};

export default function CharacterCard({ character, index = 0 }) {
  const cover = character.gallery_paths?.[0] ? `${API}/files/${character.gallery_paths[0]}` : null;
  const price = ((character.price_cents || 0) / 100).toFixed(2);
  return (
    <Link
      to={`/character/${character.id}`}
      className="gold-frame paper-scroll rounded-sm overflow-hidden block group hover:border-[#D9B472] transition-colors duration-200"
      style={{ animation: `fade-in-up 0.6s ease-out ${index * 60}ms both` }}
      data-testid={`character-card-${character.id}`}
    >
      <div className="aspect-[4/5] relative bg-gradient-to-br from-[#2b2620] to-[#0D0C0A] overflow-hidden">
        {cover ? (
          <img src={cover} alt={character.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            {character.character_type === "rpg" ? <Swords className="w-14 h-14 text-[#D9B472] opacity-40" /> : <Skull className="w-14 h-14 text-[#D9B472] opacity-40" />}
          </div>
        )}
        <div className="absolute top-2 right-2 chip bg-[#0D0C0A]/80 backdrop-blur">
          {TYPE_LABEL[character.character_type] || character.character_type}
        </div>
        {character.license_tier === "roleplay" && (
          <div className="absolute top-2 left-2 chip bg-[#8C3A34]/80 backdrop-blur text-[#F7E5DE] border-[rgba(233,184,168,0.3)]">
            <Heart className="w-3 h-3 inline mr-1" /> Roleplay license
          </div>
        )}
      </div>
      <div className="p-5">
        <h3 className="font-serif-display text-xl text-[#F7F3EC] group-hover:text-[#E6B860] transition-colors mb-1 line-clamp-1">{character.name}</h3>
        <p className="font-serif-body text-sm text-[#A8A095] italic line-clamp-2 mb-3">{character.hook}</p>
        <div className="flex items-center justify-between pt-3 border-t border-[rgba(217,180,114,0.1)]">
          <div className="text-[10px] uppercase tracking-widest text-[#6E675E] font-mono-brass truncate">
            by <span className="text-[#D9B472]">{character.author_pseudonym}</span>
          </div>
          <div className="font-mono-brass text-sm text-[#E6B860]">${price}</div>
        </div>
        {character.rating_count > 0 && (
          <div className="mt-2"><StarRating avg={character.avg_rating || 0} count={character.rating_count || 0} /></div>
        )}
        {character.tags?.length > 0 && (
          <div className="mt-3 flex flex-wrap gap-1">
            {character.tags.slice(0, 3).map((t) => (
              <span key={t} className="text-[10px] font-mono-brass px-2 py-0.5 border border-[rgba(217,180,114,0.15)] text-[#A8A095] rounded-sm">{t}</span>
            ))}
          </div>
        )}
      </div>
    </Link>
  );
}
